import { Component, Input, OnChanges, SimpleChanges } from '@angular/core'

@Component({
    selector: 'app-password-validation-status',
    template: `
    <ul class="wrapper d-flex flex-column list-unstyled password-text gap-10 gap-10-768">
      @for (status of validateArr; track status) {
        <li [class]="{'custom-validation-error': status.color === 'red' , 'green': status.color === 'green'}">{{status.text}}</li>
      }
    </ul>
    `,
    styleUrls: ['./pasword-validation-status.component.scss'],
    imports: []
})
export class PasswordValidationStatusComponent implements OnChanges {
  @Input() password = ''
  @Input() checkList: any = {
    minLength: 'At least 8 characters',
    hasOneUpperCase: 'One upper case letter',
    hasOneLowerCase: 'One lower case letter',
    hasOneNumber: 'One number',
    hasSpecialChar: 'One Special character (excluding ₹)'
  }
  private patterns = {
    hasSpecialChar: /.*[@$!%*#?&"'()+`.,/:;<=>[\]^_|{}~\\-]/g,
    minLength: /^.{8,}/g,
    hasOneUpperCase: /.*[A-Z]/g,
    hasOneLowerCase: /.*[a-z ]/g,
    hasOneNumber: /.*[0-9]/g
  }
  public validateArr: any = []

  ngOnChanges (changes: SimpleChanges): void {
    const value = changes['password'].currentValue
    this.validateArr = []
    for (const patternName in this.patterns) {
      if (Object.prototype.hasOwnProperty.call(this.patterns, patternName)) {
        const pattern = this.patterns[patternName as keyof typeof this.patterns]
        if (value && value.match(pattern)) {
          this.validateArr.push({
            text: this.checkList[patternName],
            color: 'green'
          })
        } else {
          this.validateArr.push({ text: this.checkList[patternName], color: 'red' })
        }
      }
    }
  }
}
